import React, { useState,useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import "./ListBox.css";
import "../Styles/SvgCommand.css";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";
import useSetRowData from "../../../Hooks/useSetRowData.js";
import { store } from "../../../store.js";
import CustomLoading from "../../SimpleModal/CustomLoading";

export default function ListBox(props) {
  const [isDragOver, setDragover] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();
  const setRowData = useSetRowData();
  const [data, setData] = useState({actualize:props.data.properties.actualize.value});
  const axiosOperation = useAxiosOperation();
  const history = useHistory();
  const isMenuItem = () => {
    return props.data.properties.menuItem.value
  };
  const [loaded, setLoaded] = useState(true);

  const globalState = useContext(store);
  const { dispatch } = globalState;

  const dataMenu = props.data.properties.data
  const option = dataMenu.option  && dataMenu.option.toLowerCase() //&& props.data.option.filter(item => item.type == "properties" && item.menu == "data")[0]
  
  const currentMenuItemData = isMenuItem() && option && dataMenu.value[option].values
    .filter(value => value.id == dataMenu.value[option].id)[0]

    
  const [menu, setMenu] = useState({menuItems:currentMenuItemData});
  
  useEffect(() => {
     props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);
  
  
  useEffect(() => {
    setData({...data, actualize:props.data.properties.actualize.value})
  }, [props.data.properties.actualize.value]);


  const getNode = (nodes, id) => {
    let node = nodes.map(child => {
      if (child.id == id)
        return child
      else
        return getNode(child.childs, id)
    })
    return node.flat(Infinity)
  }

  const onClickNext = (menuItem) => {
    setMenu({menuItems:menuItem})
  };

  const onClickPrevious = (id) => {
    const parentNode = getNode(currentMenuItemData.details,id)[0]
    const currentNode = parentNode.isRoot ? currentMenuItemData.details 
    : getNode(currentMenuItemData.details, parentNode.parent.id)[0]
    setMenu({menuItems: currentNode})
  
  };


  const getCurrentMenuData = (menuItem) => {
    
    
    let currentChild = menu.menuItems ? 
                          menu.menuItems.childs ? menu.menuItems.childs :menuItem.details 
                       : currentMenuItemData.details

    return currentChild.map(item => 
       {return {id:item.key.value, item:item.key.value, value:item.value.value, childs:item.childs
        , isNextActif: item.childs.length > 0, isPreviousActif:!item.isRoot,
        parent:item.parent 
      
      }})
  
  };
 
  const getContainerStyle = () => {
    var newStyle = buildStyle(props.style);
    //newStyle["position"] = "absolute";
    
    
    newStyle["border"] = isDragOver ? "1px dashed #1f79e1" :
    props.errors ? props.errors.border : props.style.border.value;
    return newStyle;
  };
  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };
  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
  };

  const getCurrentData = () => {
    
    if (isMenuItem())
      return getCurrentMenuData(currentMenuItemData) 
    else {
      if (option == "mapping") {
        
        return setRowData(JSON.parse(JSON.stringify(props.data)),{start: 0, end:100 })
        //return option && (dataMenu.value[option].data ? dataMenu.value[option].data : [])
      }
      else
        return option && dataMenu.value[option].values ? 
          dataMenu.value[option].values.filter(item => item.id == dataMenu.value[option].id)[0].details.map(detail => {return {id:detail.key.value, item:detail.value.value}}) : []
    }
  
  };

  const getInitialValue = () => {
    if (props.onlyLabel)
      return typeof props.data.properties.text.value === 'object' ? "ListBox" : props.data.properties.text.value
    if (isMenuItem())
      return currentMenuItemData && currentMenuItemData.item
    else
      return props.data.properties.text.value.item
  };
  
  const getStyle = () => {
    var newStyle = {};

    newStyle["width"] = parseInt(props.style.width.value.slice(0,-2)) - 10 + "px" ;
    newStyle["height"] = parseInt(props.style.height.value.slice(0,-2)) - 10 + "px" ;
    newStyle["top"] = props.style.top && props.style.top.value;
    newStyle["left"] = props.style.left && props.style.left.value;
    newStyle["position"] = "absolute";
    return newStyle;
  };

  const onSelectProfil = (itemSelected) => {
    const value =  itemSelected.value
    setLoaded(false)
    axiosOperation({method:"GET"
      , url: "https://flex-services.onrender.com/settingsStep/"+ value[0] + "/"+ value[1] + "/"
    }, true).then(response => 
        { 
          
         if(response.managedError) {
            
            const result = response.result.data
            const withForm = result.task.values.length > 0 && result.task.values[0].Form != null
            const formData = withForm ? result.task.values[0].Form.formData : undefined
            if (formData) {
              
              dispatch({
                type: formData ? "INITIALIZE_FORM" : "REFRESH_FORM",
                payload: {formData: formData},
              });
              
              history.push('/customHome')
              setLoaded(true)
            } //else alert("error")
         } //else alert("error")
       
          
        })
    
  }

  const onSelectItem = (itemSelected) => {
    if (isMenuItem) {
      onSelectProfil(itemSelected)
    }
    else
      props.onChange(undefined, itemSelected)
  };

  const getListBox  = () => {
    return (
      //<div style={{position:props.style.position, width:props.style.width, height:props.style.height} } >
        <React.Fragment >
      <div
        onClick={props.onClick} 
        style={getContainerStyle()}
        id={props.data.id}
      >
      </div>
       <div className="accordionText" 
          draggable={props.draggable}
          onDragStart={(e) => props.onDragStart(e)}
          onDrop={(e) => props.onlyLabel && onDropColumn(e)}
          onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
          onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
          onClick={(e) => props.onClick(e)}
          onMouseLeave={(e) => props.onMouseLeave(e)}
          //onMouseOver={(e) => props.onMouseOver(e)}
          onMouseEnter={(e) => props.onMouseEnter(e)}
          onMouseDown={(e) => props.onMouseDown(e)}
          style={getStyle()}>
        { (!isMenuItem() || (isMenuItem() && currentMenuItemData)) && 
          <DropDownListNew
            fontSize={props.style.fontSize.value}
            fontFamily={props.style.fontFamily.value}
            color={props.style.color.value}
            minWidth={props.data.properties.width.value}
            currentData={getCurrentData()}
            initialValue={getInitialValue()}
            id={"ListBox" + props.data.id}
            onDropDownItemClick={(itemSelected) => onSelectItem(itemSelected)}
            onClickNext={(itemSelected) => onClickNext(itemSelected)}
            onClickPrevious={(parent) => onClickPrevious(parent.id)}
            onlyLabel={props.onlyLabel}/>
      }
     </div>
     </React.Fragment>
     //</div>
    );

  };
  
  const isAddInGrid  = () => {
    return props.style.position == "relative"
  };

  return ( isAddInGrid() ? 
    //<div style={{position:props.style.position, width:props.style.width.value, height:props.style.height.value} }>
      getListBox()
    //</div>
    :  <React.Fragment>
        {!loaded && <CustomLoading />}
        {getListBox()}
        {props.errors && !props.errors.isColumn &&  <input readOnly style={props.errors.styles} value={props.errors.value} />}
    </React.Fragment>
  )
/*
    //<div style={{position:props.style.position, width:props.style.width, height:props.style.height} } >
      <React.Fragment >
    <div
      onClick={props.onClick} 
      style={getContainerStyle()}
      id={props.data.id}
    >
    </div>
     <div className="accordionText" 
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onDrop={(e) => props.onlyLabel && onDropColumn(e)}
      onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
      onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
      onClick={props.onClick} 
      style={getStyle()}>
     <DropDownListNew
       fontSize={props.style.fontSize}
       fontFamily={props.style.fontFamily}
       color={props.style.color}
       currentData={getCurrentData()}
       initialValue={props.data.properties.text.value.item}
       id={"ListBox" + props.data.id}
       onDropDownItemClick={(itemSelected) => props.onChange(itemSelected)}
       onlyLabel={props.onlyLabel}
     />
   </div>
   </React.Fragment>
   //</div>
  );*/
}
